import styled from 'styled-components';
import mediaQuery from 'styles/mediaQuery';

export const HeroHeading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const HeroEyebrow = styled.p`
  margin: 0 0 ${({ theme }) => theme.spaces.padding.md};
  font-size: ${({ theme }) => theme.typography.sizes.xl};
  line-height: ${({ theme }) => theme.typography.lineHeight.tight};
  letter-spacing: 0%;
  font-weight: ${({ theme }) => theme.typography.weight.semibold};
  color: ${({ theme }) => theme.system.neutral.text.primary};
`;

export const HeroTitle = styled.h1`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.sizes['4xl']};
  line-height: ${({ theme }) => theme.typography.lineHeight.tight};
  font-weight: ${({ theme }) => theme.typography.weight.bold};
  letter-spacing: -0.03em;
  color: ${({ theme }) => theme.system.neutral.text.primary};

  ${mediaQuery.xs} {
    font-size: ${({ theme }) => theme.typography.sizes['3xl']};
  }
`;

export const HeroSubtitle = styled.p`
  margin: 0;
  line-height: ${({ theme }) => theme.typography.lineHeight.tight};
  font-weight: ${({ theme }) => theme.typography.weight.regular};
  font-size: ${({ theme }) => theme.typography.sizes.lg};
  letter-spacing: 0%;
  color: ${({ theme }) => theme.system.neutral.text.primary};
`;

export const HeroVisual = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spaces.padding.xxl} 0;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: ${({ theme }) => theme.spaces.padding['3xl']};
    right: -24px;
    background: ${({ theme }) => theme.system.blue.surface.subtle};
    border-radius: ${({ theme }) => theme.radius.large};
  }

  img {
    position: relative;
  }

  ${mediaQuery.xs} {
    padding: ${({ theme }) => theme.spaces.padding.lg} 0;

    &::before {
      left: ${({ theme }) => theme.spaces.padding.lg};
      right: 0;
    }
  }
`;
